import { useEffect, useState } from 'react';
import { useCreateOrganizerMutation } from '../../Api/organizers';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Modal from '../../Style-guide/Modal';
import notify from '../../Style-guide/ToastMessage';

const organizerDetails = {
  firstName: '',
  lastName: '',
  phone: '',
  password: '',
};

const CreateOrganizerModal = (props) => {
  const { isModalOpen, setIsModalOpen } = props;
  const { mutate: createOrganizerRequest, isSuccess } = useCreateOrganizerMutation();
  const [organizerInputs, setOrganizerInputs] = useState({ ...organizerDetails });

  useEffect(() => {
    if (isSuccess) {
      setOrganizerInputs({ ...organizerDetails });
      setIsModalOpen(false);
    }
    /// disabled to prevent unnecessary modal bug caused by auto filled dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = name === 'phone' ? formatPhoneNumber(value) : value;

    setOrganizerInputs((prevFields) => ({
      ...prevFields,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const hasMissingFields = Object.values(organizerInputs).some(
      (field) => !String(field).trim()
    );

    if (hasMissingFields) {
      notify.info('Fill all the inputs');

      return;
    }

    createOrganizerRequest({
      data: organizerInputs,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <Modal
      show={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      className='create-organizer-modal'
    >
      <Input
        type='text'
        name='firstName'
        label="organizer's name"
        value={organizerInputs.firstName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />
      <Input
        type='text'
        name='lastName'
        label="organizer's surname"
        value={organizerInputs.lastName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />
      <Input
        type='tel'
        name='phone'
        label='Phone number'
        value={organizerInputs.phone}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />
      <Input
        type='password'
        name='password'
        label='Password'
        className='organizer-form-input'
        value={organizerInputs.password}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
      />

      <Button $block className='create-organizer-btn' onClick={handleSubmit}>
        Submit
      </Button>
    </Modal>
  );
};

export default CreateOrganizerModal;
